export default "__VITE_ASSET__7b5cc6ea__"